import { getTrainingMlflowArtifactText } from "@/api";
import { isHttpClientError } from "@/http";

// 학습 config 전문 한 건. source 는 사용자에게 표시할 출처 라벨이다.
export type TrainingSessionConfigDocument = {
  source: string;
  body: string;
};

const CONFIG_ARTIFACT_PATHS = ["config.yaml", ".hydra/config.yaml", "config/config.yaml"] as const;

export async function loadConfigDocument(
  runId: string,
): Promise<TrainingSessionConfigDocument | null> {
  // 경로별 404 가 다음 후보를 막지 않도록 후보를 병렬로 조회하고, 정해진 우선순위로 첫 본문을 고른다.
  const settled = await Promise.allSettled(
    CONFIG_ARTIFACT_PATHS.map(async (path) => ({
      source: `MLflow · ${path}`,
      body: (await getTrainingMlflowArtifactText(runId, path)).body,
    })),
  );
  const document = settled.find(
    (result): result is PromiseFulfilledResult<TrainingSessionConfigDocument> =>
      result.status === "fulfilled" && result.value.body.trim() !== "",
  );
  if (document) {
    return document.value;
  }
  // 빈 응답과 404 는 미제공으로 본다. 인증·서버·네트워크 오류는 숨기지 않는다.
  const unexpectedFailure = settled.find(
    (result) =>
      result.status === "rejected" &&
      (!isHttpClientError(result.reason) || result.reason.status !== 404),
  );
  if (unexpectedFailure?.status === "rejected") {
    throw unexpectedFailure.reason;
  }
  return null;
}
